import React from 'react'
import Link from 'gatsby-link'
// import api from '../api/api.json'

import HomeProjects from '../components/home-projects'
import ComoLoHacemos from '../components/comolohacemos'
import SwiperCustomers from '../components/customers'

import './index.styl'


const IndexPage = ({data}) => {
    console.log(data);
    // console.log(api);
    // const contentHome = api.contents[1].projects_featured
    return (
        <div>
        	<div>
                <div className="ContentsContainer">
                    <SwiperCustomers/>
                </div>
        	    <div className="HomeWrapper">
                    <div className="ContentsContainer IndexStyle">
                        <h2>Users Are First (UAF)</h2>
                        <p>Creamos esta filosofía en el desarrollo de productos, pensado en las personas que realmente los consumen día a día. Somos aliados de los modelos de compañias en crecimiento, <strong>startups</strong> por que conocemos el medio y por que sabemos lo que se necesita para crecer de manera efectiva.</p>
                    </div>
                </div>
                {/*<div className="HomeWrapper">
                                    <div className="ContentsContainer IndexStyle">
                                        <h2>Los usuarios primero (UAF)</h2>
                                        <p>Nuestra Filosofía en el desarrollo de productos y mercadeo de productos digitales esta pensado en las personas que lo consumen día a día.</p>
                                    </div>
                                </div>*/}
                {
                    data.homeData.contents.map( (item) => {
                        return <HomeProjects className="HomeProjects" {...item} key={item.id}  />
                    })
                }
                <ComoLoHacemos/>
        	</div>
        </div>
    )
}


export default IndexPage

export const query = graphql`
  query HomeDataQuery {
    homeData {
        contents {
            bg
            bgImage
            className
            commentAuthor
            commentAuthorProfile
            commentAuthorText
            id
            image
            text
            title
            work
        }
    }
  }
`




// WEBPACK FOOTER //
// ./src/pages/index.js